import React, { useState, useEffect } from 'react';
import axios from '../api/axiosConfig';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import './Profiles.css'; // Reutilizando clases de diseño estándar para mantener consistencia de marca

const ConfigNovedades = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    responsable: 'Concesionario'
  });

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      setLoading(true);
      const res = await axios.get('/api/novelties/templates');
      setTemplates(res.data);
    } catch (err) {
      console.error(err);
      alert('❌ Error al obtener las plantillas de novedades');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const resetForm = () => {
    setFormData({
      name: '',
      description: '',
      responsable: 'Concesionario'
    });
    setIsEditing(false);
    setEditingId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.responsable) {
      alert('⚠️ Por favor complete los campos obligatorios');
      return;
    }

    try {
      if (isEditing) {
        await axios.put(`/api/novelties/templates/${editingId}`, formData);
        alert('✅ Plantilla de novedad actualizada correctamente');
      } else {
        await axios.post('/api/novelties/templates', formData);
        alert('✅ Plantilla de novedad creada correctamente');
      }
      resetForm();
      fetchTemplates();
    } catch (err) {
      alert('❌ Error: ' + (err.response?.data?.message || 'No se pudo guardar la plantilla'));
    }
  };

  const startEdit = (t) => {
    setFormData({
      name: t.name,
      description: t.description || '',
      responsable: t.responsable
    });
    setIsEditing(true);
    setEditingId(t.id);
  };

  const deleteTemplate = async (id) => {
    if (!window.confirm('⚠️ ¿Está seguro de eliminar esta plantilla de novedad?')) return;
    
    try {
      await axios.delete(`/api/novelties/templates/${id}`);
      alert('✅ Plantilla eliminada correctamente');
      fetchTemplates();
    } catch (err) {
      alert('❌ Error: ' + (err.response?.data?.message || 'No se pudo eliminar la plantilla'));
    }
  };

  return (
    <div className="dashboard-container">
      <Sidebar />
      <div className="main-content">
        <Navbar />
        
        <div className="content-padding">
          <div className="dashboard-header-section" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px' }}>
            <div>
              <h2 className="dashboard-title">⚙️ Configuración de Novedades</h2>
              <p className="dashboard-subtitle">Crea y administra las plantillas de novedades del sistema y asócialas a un responsable.</p>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '30px', alignItems: 'start' }}>
            {/* Formulario */}
            <div className="card" style={{ padding: '20px' }}>
              <h3 style={{ marginBottom: '20px', fontSize: '16px', fontWeight: '800', color: 'var(--text-primary)' }}>
                {isEditing ? '✏️ Editar Plantilla' : '➕ Crear Nueva Plantilla'}
              </h3>
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <label style={{ fontSize: '11px', fontWeight: '700', color: 'var(--text-secondary)' }}>
                    NOMBRE DE LA NOVEDAD <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Ej. Falta firma de improntas"
                    required
                    style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid var(--card-border)' }}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <label style={{ fontSize: '11px', fontWeight: '700', color: 'var(--text-secondary)' }}>
                    RESPONSABLE DE RESOLVER <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    name="responsable"
                    value={formData.responsable}
                    onChange={handleInputChange}
                    required
                    style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid var(--card-border)', background: 'var(--card-bg)', color: 'var(--text-primary)' }}
                  >
                    <option value="Concesionario">Concesionario</option>
                    <option value="Operador">Operador</option>
                    <option value="Tránsito">Tránsito</option>
                    <option value="Validador">Validador</option>
                    <option value="Cliente">Cliente</option>
                  </select>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <label style={{ fontSize: '11px', fontWeight: '700', color: 'var(--text-secondary)' }}>
                    DESCRIPCIÓN / INSTRUCCIONES
                  </label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    placeholder="Instrucciones para solucionar la novedad..."
                    rows="3"
                    style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid var(--card-border)', resize: 'vertical' }}
                  />
                </div>

                <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                  {isEditing && (
                    <button
                      type="button"
                      onClick={resetForm}
                      className="btn-secondary"
                      style={{ flex: 1, padding: '10px', fontSize: '12px', fontWeight: '700' }}
                    >
                      Cancelar
                    </button>
                  )}
                  <button
                    type="submit"
                    className="btn-primary"
                    style={{ flex: 2, padding: '10px', fontSize: '12px', fontWeight: '700' }}
                  >
                    {isEditing ? 'Guardar Cambios' : 'Crear Plantilla'}
                  </button>
                </div>
              </form>
            </div>

            {/* Listado */}
            <div className="card" style={{ padding: '20px' }}>
              <h3 style={{ marginBottom: '20px', fontSize: '16px', fontWeight: '800', color: 'var(--text-primary)' }}>
                📋 Plantillas Activas ({templates.length})
              </h3>
              
              {loading ? (
                <div style={{ padding: '40px', textAlign: 'center', color: 'var(--text-secondary)' }}>
                  Cargando plantillas...
                </div>
              ) : templates.length === 0 ? (
                <div style={{ padding: '40px', textAlign: 'center', color: 'var(--text-secondary)', border: '2px dashed var(--card-border)', borderRadius: '12px' }}>
                  No hay plantillas de novedades configuradas
                </div>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <div className="table-responsive">
                    <table className="user-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'left', padding: '12px 8px' }}>Nombre</th>
                        <th style={{ textAlign: 'left', padding: '12px 8px' }}>Descripción</th>
                        <th style={{ textAlign: 'left', padding: '12px 8px' }}>Responsable</th>
                        <th style={{ textAlign: 'center', padding: '12px 8px', width: '150px' }}>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {templates.map((t) => (
                        <tr key={t.id} style={{ borderBottom: '1px solid var(--card-border)' }}>
                          <td style={{ padding: '12px 8px', fontWeight: '700', color: 'var(--text-primary)' }}>{t.name}</td>
                          <td style={{ padding: '12px 8px', fontSize: '12px', color: 'var(--text-secondary)' }}>{t.description || 'Sin descripción'}</td>
                          <td style={{ padding: '12px 8px' }}>
                            <span style={{
                              padding: '4px 8px',
                              borderRadius: '6px',
                              fontSize: '11px',
                              fontWeight: '800',
                              background: 'rgba(37, 99, 235, 0.1)',
                              color: '#2563eb'
                            }}>
                              👤 {t.responsable.toUpperCase()}
                            </span>
                          </td>
                          <td style={{ padding: '12px 8px', textAlign: 'center' }}>
                            <button
                              onClick={() => startEdit(t)}
                              className="btn-action btn-edit"
                              style={{
                                background: 'rgba(245, 158, 11, 0.1)',
                                color: '#d97706',
                                border: '1px solid rgba(245, 158, 11, 0.2)',
                                padding: '6px 10px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                                marginRight: '5px'
                              }}
                              title="Editar plantilla"
                            >
                              ✏️
                            </button>
                            <button
                              onClick={() => deleteTemplate(t.id)}
                              className="btn-action"
                              style={{
                                background: 'rgba(239, 68, 68, 0.1)',
                                color: '#dc2626',
                                border: '1px solid rgba(239, 68, 68, 0.2)',
                                padding: '6px 10px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                transition: 'all 0.2s'
                              }}
                              title="Eliminar plantilla"
                            >
                              🗑️
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfigNovedades;
